import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAdminNotifications } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canEditOtherUserNotificationSettings } from "@/helpers/permissions";
import { canEditOwnNotificationSettings } from "@/modules/admin-notifications/permissions";

import { AdminNotificationsPage } from "./pages/list/AdminNotificationsPage";
import { NotificationSettingsPage } from "./pages/settings/NotificationSettingsPage";
import { adminNotificationsRoutes } from "./routes";

export const adminNotificationsRoute = [
  {
    path: adminNotificationsRoutes.list,
    element: (
      <RequireAuth permission={canAccessAdminNotifications}>
        <AdminNotificationsPage />
      </RequireAuth>
    ),
  },
  {
    path: adminNotificationsRoutes.selfSettings,
    element: (
      <RequireAuth permission={canEditOwnNotificationSettings}>
        <NotificationSettingsPage />
      </RequireAuth>
    ),
  },
  {
    path: adminNotificationsRoutes.otherUserSettings,
    element: (
      <RequireAuth permission={canEditOtherUserNotificationSettings}>
        <NotificationSettingsPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
